import { useState } from 'react';

const testimonials = [
  {
    quote:
      "Family Tree Maker is simply the best genealogy software available. It's intuitive, powerful, and has helped me discover so much about my family history.",
    name: 'John S.',
    location: 'San Jose, CA',
    rating: 5,
  },
  {
    quote:
      "I've been using Family Tree Maker for over 10 years and it just keeps getting better. The cloud sync feature is a game-changer!",
    name: 'Mary K.',
    location: 'Austin, TX',
    rating: 5,
  },
  {
    quote:
      'The integration with FamilySearch makes research so much easier. I\'ve found ancestors I never knew existed!',
    name: 'Robert T.',
    location: 'Seattle, WA',
    rating: 5,
  },
];

export default function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const current = testimonials[currentIndex];

  const nextTestimonial = () => setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  const prevTestimonial = () => setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-[#2d2520] mb-6">
          What Our Customers Say
        </h2>
        <div className="section-divider w-24 mx-auto mb-12" />
        <div className="max-w-4xl mx-auto">
          <div className="bg-[#e8f5e9] rounded-2xl p-8 md:p-14 border border-[#22c55e]/30 relative">
            <button
              type="button"
              onClick={prevTestimonial}
              className="hidden md:flex absolute left-4 top-1/2 -translate-y-1/2 bg-[#22c55e] hover:bg-[#16a34a] text-white rounded-full w-10 h-10 items-center justify-center transition-colors"
              aria-label="Previous testimonial"
            >
              ←
            </button>
            <button
              type="button"
              onClick={nextTestimonial}
              className="hidden md:flex absolute right-4 top-1/2 -translate-y-1/2 bg-[#22c55e] hover:bg-[#16a34a] text-white rounded-full w-10 h-10 items-center justify-center transition-colors"
              aria-label="Next testimonial"
            >
              →
            </button>

            <div className="text-center">
              <p className="text-lg md:text-xl text-[#4a4038] italic mb-6 leading-relaxed">
                &ldquo;{current.quote}&rdquo;
              </p>
              <div className="flex justify-center gap-1 mb-4">
                {Array.from({ length: current.rating }).map((_, i) => (
                  <svg key={i} className="w-5 h-5 md:w-6 md:h-6 text-[#22c55e]" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
                ))}
              </div>
              <p className="text-base font-semibold text-[#2d2520]">
                {current.name}, {current.location}
              </p>
            </div>

            <div className="flex flex-col items-center gap-4 mt-8">
              <div className="flex justify-center gap-2">
                {testimonials.map((_, index) => (
                  <button
                    key={index}
                    type="button"
                    onClick={() => setCurrentIndex(index)}
                    className={`w-3 h-3 rounded-full transition-colors ${
                      index === currentIndex ? 'bg-[#22c55e]' : 'bg-[#d4cfc4]'
                    }`}
                    aria-label={`Go to testimonial ${index + 1}`}
                  />
                ))}
              </div>
              <div className="flex gap-4 md:hidden">
                <button
                  type="button"
                  onClick={prevTestimonial}
                  className="bg-[#22c55e] hover:bg-[#16a34a] text-white rounded-full w-10 h-10 flex items-center justify-center transition-colors shadow-md"
                  aria-label="Previous testimonial"
                >
                  ←
                </button>
                <button
                  type="button"
                  onClick={nextTestimonial}
                  className="bg-[#22c55e] hover:bg-[#16a34a] text-white rounded-full w-10 h-10 flex items-center justify-center transition-colors shadow-md"
                  aria-label="Next testimonial"
                >
                  →
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
